import AddUserForm from '../../components/add-user-form';

export default function AddUserPage() {
  return (
    <div className="h-full">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Add User</h1>
      </div>
      <div className="w-full max-w-4xl mx-auto">
        <AddUserForm />
      </div>
    </div>
  );
}
